<template>
  <div class="grid grid-cols-5 col-span-5 pt-4 conversation-answer-end">
    <vx-tooltip :text="tooltip"
                position="top"
                delay="0.5s"
                class="col-span-3 col-start-3"
    >
      <div class="flex flex-col items-center">
        <router-link v-if="answerId && answerName && botId"
                     :to="{name: ROUTE_NAMES.answers, params: { botId, answerId}}"
                     class="answer-end-link mt-2 hover:underline flex flex-col items-center w-full rounded-full hover:ring-2 hover:ring-primary"
                     @click.stop
                     target="_blank"
                     rel="noopener"
        >
          <answer-end-arrow :type="type" class="answer-end-link-arrow" />
        </router-link>

        <answer-end-arrow v-else :type="type" />
      </div>
    </vx-tooltip>
  </div>
</template>

<script>
import AnswerEndArrow from '../../../common/AnswerEndArrow.vue'
import { ANSWER_END } from '@/utils/bot-json.constants'
import { ROUTE_NAMES } from '@/router'

export default {
  name: 'ConversationAnswerEnd',

  data() {
    return {
      ANSWER_END,
      ROUTE_NAMES
    }
  },

  components: {
    AnswerEndArrow
  },

  props: {
    type: {
      type: String,
      required: true
    },
    answerId: {
      type: String,
      default: null
    },
    botId: {
      type: String,
      default: null
    },
    answersById: {
      type: Object,
      default: () => ({})
    }
  },

  computed: {
    answerName() {
      return this.answersById?.[this.answerId]?.name
    },
    tooltip() {
      return {
        [ANSWER_END.FIND_INTENT]: 'Find Answer',
        [ANSWER_END.IDLE]: 'Call operator',
        [ANSWER_END.CONTINUE_ANSWER]: `Continue to Answer: ${this.answerName}`
      }[this.type]
    }
  }
}
</script>

<style scoped>
::v-deep .answer-end-link:hover .answer-end-link-arrow {
  filter: invert(42%) sepia(86%) saturate(2475%) hue-rotate(232deg) brightness(98%) contrast(95%)
}
</style>
